import ModalTitleContainer from "../../../../components/Modal/components/ModalTitleContainer";
import dayjs from "dayjs";
import {StyledButton} from "../../../../components/Buttons/DefaultButton/DefaultButton.styles";
import React, {FC} from "react";
import {JobWithInvoiceProps} from "../InvoicePage";
import {ShiftContainer} from "../InvoicePage.styles";

interface PayInvoiceProps {
    job: JobWithInvoiceProps;
    onPayInvoice: () => void;
    onCloseButtonClick: () => void;

}

export const PayInvoiceModal: FC<PayInvoiceProps> = (
    {
        job: data,
        onPayInvoice,
        onCloseButtonClick
    }) => {
    const invoiceAmtWithFee = (data.invoice.totalInvoiceAmt + (data.invoice.totalInvoiceAmt * 0.0475)).toFixed(2)
    return (
        <>
            <ModalTitleContainer title={'Pay This Invoice?'} onClose={onCloseButtonClick} />

            <ShiftContainer>
                We will process payment for this invoice and forward it directly to {data.hygienist.firstName}.
                A small processing fee of 4.75% applies to the payment, just to cover our transaction costs of sending this payment to {data.hygienist.firstName}.
                <br/><br/><b>Invoice #{data.invoice.jobId}</b>
                <br/><b>Date:</b> {dayjs.utc(data.startDate).format('MMM D, YYYY')}
                <br/><b>Invoice Amount:</b> ${data.invoice.totalInvoiceAmt.toFixed(2)}
                <br/><b>Processing Fee:</b> 4.75%
                <br /><br /><b>Total Payable: ${invoiceAmtWithFee}</b>
                <br /><br />Once payment is successfully processed, we'll e-mail you a copy of the paid invoice receipt.
                Payment is secure using bank-level encryption. Pay now?
            </ShiftContainer>

            <StyledButton
                variant="contained"
                color="primary"
                size="large"
                id="continue-button"
                onClick={onPayInvoice}
            >
                Confirm
            </StyledButton>
            <StyledButton
                variant="outlined"
                color="primary"
                size="large"
                id="continue-button"
                onClick={onCloseButtonClick}
            >
                Cancel
            </StyledButton>
        </>
    );
}